import React, { FC, memo, ReactNode } from 'react';

import { dom } from 'app/utils';
import { View, IView, ITemplate } from '../data';
import { IInput } from './types';

export interface ICollection<T = any> extends IInput<T[]> {
  template?: (item: T, index: number, options: ITemplate) => ReactNode;
}

export const Collection: FC<ICollection> = memo(({ id, className, style, disabled, value, invalid, readOnly, template, onBlur, onChange, onFocus }) => {
  const view: IView<any> = { id, style, disabled,
    className: dom.className('i-component', 'i-collection', { 'i-invalid': invalid }, className),
    items: (readOnly ? value : [ ...(value ?? []), null ]),
    template: dom.handle(template, (n, i) => [n, i, { onBlur, onChange, onFocus }]) ?? (() => null),
  };

  return (
    <View { ...view } />
  );
});
